export const environment = {
    production: false,
    baseUrl: 'https://rabiz-rails-api.herokuapp.com/',
    date:"02-03-2021"
  };
